import * as BasicLightbox from './Vendor/BasicLightbox/basicLightbox.min.js';

export default class SgVideoLightbox {
	/**
	 * Initializes the LightboxManager with the necessary parameters.
	 */
	constructor() {
		const videoItems = document.querySelectorAll('.sg-video-item');
		const isMobile = window.matchMedia('(max-width: 679px)').matches;

		videoItems.forEach((item) => {
			if (
				(item.dataset.disableLightboxMobile === '1' && isMobile) ||
				(item.dataset.disableLightbox === '1' && !isMobile)
			) {
				item.classList.remove('sg-video-item');
				item.addEventListener('click', SgVideoLightbox.disableLightbox.bind(this));
			}
		});

		Array.prototype.forEach.call(document.querySelectorAll('.sg-video-item'), (element) => {
			element.addEventListener('click', SgVideoLightbox.openLightbox);
		});
	}

	/**
	 * Opens the lightbox
	 *
	 * @param {Event} event
	 */
	static openLightbox(event) {
		event.preventDefault();
		const isShorts = event.target.closest('a')?.dataset?.isShorts === '1';
		switch (event.target.closest('a')?.dataset?.videoType) {
			case 'youtube': {
				SgVideoLightbox.openYouTubeLightBox(event, isShorts);
				break;
			}
			case 'vimeo': {
				SgVideoLightbox.openVimeoLightBox(event);
				break;
			}
			case 'custom': {
				SgVideoLightbox.openCustomLightBox(event);
				break;
			}
			default:
			// do nothing
		}
	}

	/**
	 * Disables the lightbox
	 *
	 * @param {Event} event
	 */
	static disableLightbox(event) {
		event.preventDefault();
		const isShorts = event.target.closest('a')?.dataset?.isShorts === '1';
		switch (event.target.closest('a')?.dataset?.videoType) {
			case 'youtube': {
				SgVideoLightbox.disableYouTubeLightbox(event, isShorts);
				break;
			}
			case 'vimeo': {
				SgVideoLightbox.disableVimeoLightbox(event);
				break;
			}
			case 'custom': {
				SgVideoLightbox.disableCustomLightbox(event);
				break;
			}
			default:
			// do nothing
		}
	}

	/**
	 * Opens the lightbox for vimeo videos
	 *
	 * @param event
	 */
	static openVimeoLightBox(event) {
		let url = event.target.closest('.sg-video-item').href;
		url = SgVideoLightbox.includeAdditionalUrlParameters(
			url,
			event.target.closest('a').dataset.additionalUrlParameters,
		);
		url += '&autoplay=1&dnt=1';

		const instance = BasicLightbox.create(
			`<iframe class="sg-video-iframe sg-video-vimeo-iframe mfp-iframe" frameborder="0" allowfullscreen allow="autoplay; fullscreen *; picture-in-picture" src="${url}" aria-label="Vimeo video player"></iframe>`,
			{
				closable: true,
			},
		);

		instance.show(() => SgVideoLightbox.renderCloseButton(instance));
	}

	/**
	 * Opens the lightbox with the youtube player (uses youtube-nocookie)
	 *
	 * @param {Event} event
	 * @param {boolean} isShorts
	 */
	static openYouTubeLightBox(event, isShorts) {
		let url = event.target.closest('.sg-video-item').href;
		const videoId = SgVideoLightbox.getYouTubeVideoIdFromUrl(url);
		url = `https://www.youtube-nocookie.com/embed/${videoId}`;
		url = SgVideoLightbox.includeAdditionalUrlParameters(
			url,
			event.target.closest('a').dataset.additionalUrlParameters,
		);

		const iframeClass = isShorts
			? 'sg-video-iframe sg-video-youtube-iframe sg-video-youtube-shorts-iframe'
			: 'sg-video-iframe sg-video-youtube-iframe';

		const instance = BasicLightbox.create(
			`
			<iframe allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
			class="${iframeClass}" src="${url}" aria-label="YouTube video player"></iframe>
		`,
			{
				closable: true,
			},
		);

		instance.show(() => SgVideoLightbox.renderCloseButton(instance));
	}

	/**
	 * Replace the image with an iframe
	 *
	 * @param {Event} event
	 * @param {boolean} isShorts
	 *
	 */
	static disableYouTubeLightbox(event, isShorts) {
		event.preventDefault();
		const item = event.currentTarget;
		item.classList.add('no-lightbox');

		const videoId = SgVideoLightbox.includeAdditionalUrlParameters(
			SgVideoLightbox.getYouTubeVideoIdFromUrl(item.href),
			item.dataset.additionalUrlParameters,
		);
		const videoImage = item.querySelector('.sg-video__image');
		const originalWidth = videoImage.offsetWidth;
		const originalHeight = videoImage.offsetHeight;

		// Calculate iframe dimensions
		let iframeWidth = originalWidth;
		let iframeHeight = originalHeight;
		if (isShorts) {
			// Maintain 9:16 aspect ratio for Shorts
			iframeWidth = originalWidth;
			iframeHeight = Math.round((iframeWidth / 9) * 16);
		}

		const iframe = document.createElement('iframe');
		iframe.width = iframeWidth;
		iframe.height = iframeHeight;
		iframe.style.border = 'none';
		iframe.allowFullscreen = true;

		if (isShorts) {
			iframe.classList.add('sg-video-youtube-shorts-iframe');
		}

		iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
		iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}`;

		if (videoImage.parentElement.nodeName.toLowerCase() === 'picture') {
			videoImage.parentElement.replaceWith(iframe);
		} else {
			videoImage.replaceWith(iframe);
		}
	}

	/**
	 * Disables the lightbox for vimeo videos
	 *
	 * @param event
	 */
	static disableVimeoLightbox(event) {
		event.preventDefault();
		const item = event.currentTarget.closest('.sg-video__item');
		const link = item.querySelector('a');
		item.classList.add('no-lightbox');

		// This needs to be done, because the height of inline elements is always 0, if on auto...
		// $vimeoItem.css('display', 'block');

		const iframeUrl = SgVideoLightbox.includeAdditionalUrlParameters(
			link.href,
			link.dataset.additionalUrlParameters,
		);
		const thumbnailElement = item.querySelector('.sg-video__image');
		const width = thumbnailElement?.clientWidth;
		const height = thumbnailElement?.clientHeight;
		const nodes = document
			.createRange()
			.createContextualFragment(
				`<div class="sg-video-item sg-card-shadow" ` +
					`style="height: ${height}px; width: ${width}px;">` +
					`<div class="embed-container" style="padding-bottom: calc(${height} / ${width}  * 100%);">` +
					`<iframe ` +
					`width="${width}" height="${height}" ` +
					`src="${iframeUrl}&dnt=1" frameborder="0" ` +
					`allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>` +
					`</iframe>` +
					`</div></div>`,
			);
		thumbnailElement?.replaceWith(nodes);
	}

	/**
	 * Opens the lightbox for local custom videos.
	 *
	 * @param {Event} event
	 */
	static openCustomLightBox(event) {
		const item = event.target.closest('.sg-video-item');
		if (!item) {
			return;
		}
		const shouldAutoplay = SgVideoLightbox.shouldAutoplayLocalVideo(item);

		const url = SgVideoLightbox.includeAdditionalUrlParameters(item.href, item.dataset.additionalUrlParameters);
		if (!url) {
			return;
		}

		const instance = BasicLightbox.create(
			`<video class="sg-video-iframe sg-video-custom-video" controls ${shouldAutoplay ? 'autoplay' : ''} playsinline preload="metadata" src="${url}" aria-label="Local video player"></video>`,
			{
				closable: true,
			},
		);

		instance.show(() => {
			const localVideoElement = document.querySelector('.basicLightbox--visible .sg-video-custom-video');
			if (shouldAutoplay && localVideoElement instanceof HTMLVideoElement) {
				void localVideoElement.play().catch(() => {});
			}
			SgVideoLightbox.renderCloseButton(instance);
		});
	}

	/**
	 * Replaces the thumbnail with a local video element when lightbox is disabled.
	 *
	 * @param {Event} event
	 */
	static disableCustomLightbox(event) {
		const item = event.currentTarget;
		if (!item) {
			return;
		}
		const shouldAutoplay = SgVideoLightbox.shouldAutoplayLocalVideo(item);

		const url = SgVideoLightbox.includeAdditionalUrlParameters(item.href, item.dataset.additionalUrlParameters);
		if (!url) {
			return;
		}

		const replacement = item.cloneNode(true);
		replacement.removeAttribute('href');
		replacement.removeAttribute('target');
		replacement.classList.remove('sg-video-item');
		replacement.classList.add('no-lightbox');
		replacement.querySelector('.sg-video__svg')?.remove();

		const thumbnailElement = replacement.querySelector('.sg-video__image');
		const videoElement = document.createElement('video');
		const thumbnailClassName = thumbnailElement?.className || 'sg-video__image object-fit-cover h-100 w-100';
		videoElement.className = thumbnailClassName.replaceAll(/\bsg-video__image--custom-fallback\b/g, '').trim();
		videoElement.controls = true;
		videoElement.autoplay = shouldAutoplay;
		videoElement.playsInline = true;
		videoElement.preload = 'metadata';
		videoElement.src = url;
		videoElement.setAttribute('aria-label', 'Local video player');

		if (thumbnailElement?.parentElement && thumbnailElement.parentElement.nodeName.toLowerCase() === 'picture') {
			thumbnailElement.parentElement.replaceWith(videoElement);
		} else if (thumbnailElement) {
			thumbnailElement.replaceWith(videoElement);
		} else {
			const overflowContainer = replacement.querySelector('.overflow-hidden');
			if (overflowContainer) {
				overflowContainer.append(videoElement);
			}
		}

		item.replaceWith(replacement);
		if (shouldAutoplay) {
			void videoElement.play().catch(() => {});
		}
	}

	/**
	 * @param {HTMLElement} item
	 * @returns {boolean}
	 */
	static shouldAutoplayLocalVideo(item) {
		return item?.dataset?.autoplayLocal === '1';
	}

	/**
	 * Extracts the Vimeo Video ID form the URL
	 *
	 * @param {string} url
	 * @return {string}
	 */
	static getVimeoVideoIdFromUrl(url) {
		const regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?(\d+)/;
		const parseUrl = regExp.exec(url);
		return parseUrl[5];
	}

	/**
	 * Prepares the given url, or returns null.
	 *
	 * @param {string} url
	 * @return {string|null}
	 */
	static getYouTubeVideoIdFromUrl(url) {
		// Match standard YouTube URL or Shorts URL
		const matches = url.match(/watch\?v=([^&?]*)(?:&list=([^&?]*))?|shorts\/([^&/?]+)/);
		if (!matches) {
			return null;
		}

		// Determine the video ID and construct the appropriate URL
		const videoId = matches[1] || matches[3];
		const listParameter = matches[2] ? `?list=${matches[2]}` : '';
		const autoplayParameters = listParameter ? '&autoplay=1&rel=0' : '?autoplay=1&rel=0';

		return `${videoId}${listParameter}${autoplayParameters}`;
	}

	/**
	 * Includes the additional URL parameters in the video url
	 *
	 * @param {string|null} url
	 * @param {string} _additionalUrlParameters
	 * @returns
	 */
	static includeAdditionalUrlParameters(url, _additionalUrlParameters = '') {
		if (!url) {
			return '';
		}

		if (!_additionalUrlParameters) {
			return url;
		}

		let additionalUrlParameters = _additionalUrlParameters;
		const beginsWithQuestionMark = additionalUrlParameters.charAt(0) === '?';
		const beginsWithAmpersand = additionalUrlParameters.charAt(0) === '&';

		if (beginsWithQuestionMark || beginsWithAmpersand) {
			additionalUrlParameters = additionalUrlParameters.slice(1);
		}

		return url.includes('?') ? `${url}&${additionalUrlParameters}` : `${url}?${additionalUrlParameters}`;
	}

	static renderCloseButton(instance) {
		const translationContainer = document.querySelector('#translation-container');
		const closeButtonContainer = document.createElement('div');
		const placeholder = document.querySelector('.basicLightbox__placeholder');

		closeButtonContainer.classList.add(
			'lightbox__close-container',
			'position-absolute',
			'top-6',
			'end-6',
			'd-flex',
			'align-items-center',
			'justify-content-center',
			'z-1000',
		);
		closeButtonContainer.innerHTML = `
			<button class="btn btn-close shadow" title="${translationContainer?.dataset?.closeText || 'Close'}" aria-label="${translationContainer?.dataset?.closeText || 'Close'}">
				<svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 384 512" aria-hidden="true" focusable="false">
					<path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/>
				</svg>
			</button>
		`;

		if (placeholder && placeholder.parentNode) {
			placeholder.parentNode.insertBefore(closeButtonContainer, placeholder.nextSibling);
		}

		closeButtonContainer.querySelector('.btn-close')?.addEventListener('click', () => instance.close());
	}
}
